import MainMenu from "./components/MainMenu";
import SearchBar from "./SearchBar/SearchBar";
import ListBox from "./components/ListBox";
import { useTranslation } from "react-i18next";
import useMainStructure from "./useMainStructure";
import { stdObject } from "../../data/types/stdObject";
import { StructureContext } from "../../context/StructureContext";
import { excludesTotal, listType } from "../../data/main";
import SalesReport from "./components/SalesReport/SalesReport";
import CommReport from "./components/CommReport/CommReport";
import CategoriesList from "./components/CategoriesList";
import { toPrice } from "../../utils/toPrice";
import { noTotalsList } from "../../data/screensSearch";
import FooterTotals from "./components/FooterTotals";
import UsersBox from "./components/UsersBox";
import HeadersBox from "./components/HeadersBox";
import MainInfoBox from "./components/MainInfoBox";
import LanguageBox from "./components/LanguageBox";
import BrandsBox from "./components/BrandsBox";
import StationeryBox from "./components/StationeryBox";
import RecordsBox from "./components/RecordsBox/RecordsBox";
import AccountingBox from "./components/AccountingBox";
import WebConnectionBox from "./components/WebConnectionBox";
import Diagram from "./components/Diagram";
import InventoryBox from "./components/InventoryBox";
import BatchesBox from "./components/BatchesBox";
import ItemMoveBox from "./components/ItemMoveBox";
import GraphsBox from "./components/GraphsBox";
import LogAccessBox from "./components/LogAccessBox";
import FieldsBox from "./components/FieldsBox";
import BackupBox from "./components/BackupBox";
import ItemMoveProfitBox from "./components/ItemMoveProfitBox";

export default function MainStructure({
  type = "",
  subSections,
  height = "0%",
  peopleId,
}: {
  type: string;
  subSections: stdObject;
  height: string;
  peopleId?: string;
}) {
  const { t } = useTranslation();
  const {
    section,
    updateSection,
    updateSearchValues,
    extraSection,
    headers,
    boxList,
    searchValues,
    setSearchValues,
    selectOptions,
    catList,
    categories,
    cleanAllSearch,
    saveInfoData,
    sendNewInfo,
    openRowInfo,
    summatoryTotals,
    findServiceData,
    scrollDiv,
    handleScroll,
    listData,
    printArea,
    prepareToPrint,
    prepareToXLS,
    headerInfo,
    closeMsg,
    openSettings,
    openExport,
    openImport,
    printList,
    callBackupInfo,
    openBackup,
  }: stdObject = useMainStructure({
    type,
    subSections,
    peopleId,
    height,
  });

  const switchScreen = () => {
    // console.log("section.id", section);
    switch (section.id) {
      case "C2": // Workshop
        return <div />;
      case "F1": // category
        return <CategoriesList />;
      case "F3": // brands
        return <BrandsBox />;
      case "F4": // item movements
        return <ItemMoveBox />;
      case "F5": // batches
        return <BatchesBox />;
      case "F10": // inventory
        return <InventoryBox />;
      case "D1": // salesReport
        return <SalesReport />;
      case "D2": // commissionsReport
        return <CommReport />;
      case "D3": // shipments
        return <AccountingBox />;
      case "D4": // Diagram
        return <Diagram />;
      case "D6": // accounting
        return <AccountingBox />;
      case "D11": // profitability
        return <ItemMoveProfitBox />;
      case "D12": // records
        return <RecordsBox />;
      case "LOG": // access log
        return <LogAccessBox />;
      case "V1": // records
        return <GraphsBox />;
      case "D8": // routes
      case "Z1": // general
      case "Z3": // branches
      case "Z4": // admin
      case "Z7": // services
      case "Z8": // accountingAdmin
      case "Z14": // rols
        return <MainInfoBox params={listType[section.id]} />;
      case "Z2": // users
        return <UsersBox />;
      case "Z5": // fields
        return <FieldsBox />;
      case "Z6": // backup
        return <BackupBox />;
      case "Z9": // web connection
        return <WebConnectionBox />;
      case "Z10": // headers
        return <HeadersBox />;
      case "Z11": // language
        return <LanguageBox />;
      case "Z12": // stationery
        return <StationeryBox />;
      default:
        return listType.std.includes(section.id) ? (
          <SalesReport />
        ) : (
          <ListBox />
        );
    }
  };

  return (
    <StructureContext.Provider
      value={{
        subSections,
        updateSection,
        type,
        section,
        updateSearchValues,
        headers,
        boxList,
        searchValues,
        setSearchValues,
        selectOptions,
        catList,
        categories,
        cleanAllSearch,
        saveInfoData,
        sendNewInfo,
        openRowInfo,
        findServiceData,
        scrollDiv,
        handleScroll,
        printArea,
        prepareToPrint,
        prepareToXLS,
        headerInfo,
        closeMsg,
        openSettings,
        openExport,
        openImport,
        printList,
        callBackupInfo,
        openBackup,
      }}
    >
      <div className="screen" style={{ height }}>
        <MainMenu extraSection={extraSection} />
        {
          <>
            {<SearchBar />}
            {switchScreen()}
            {!noTotalsList.includes(section.id) &&
              typeof section.id === "string" && (
                <div className="footerInfo">
                  <FooterTotals
                    label={t("p.quantity")}
                    value={listData.current.length}
                  />
                  {summatoryTotals() &&
                    ["NET", "IMP", "TOT", "ABO", "SAL"].map(
                      (e: string, index: number) =>
                        (!(section.code in excludesTotal) ||
                          (typeof section.code === "string" &&
                            section.code in excludesTotal &&
                            !(excludesTotal as Record<string, string[]>)[
                              section.code
                            ].includes(e))) && (
                          <FooterTotals
                            key={index}
                            label={t(`c.${e}`)}
                            value={toPrice(
                              listData.current.filtered.reduce(
                                (acc: number, curr: stdObject) =>
                                  acc +
                                  curr[
                                    e +
                                      (section.code === "CAJ"
                                        ? "ORD"
                                        : section.code)
                                  ],
                                0,
                              ),
                            )}
                          />
                        ),
                    )}
                </div>
              )}
          </>
        }
      </div>
    </StructureContext.Provider>
  );
}
